/**
 * Metadata fetch enums and hook.
 *
 * The enums are defined here canonically. The hook remains a bridge
 * because it depends on React hooks and GraphQL queries in src/.
 */

// ── Canonical enum definitions ───────────────────────────────────

export enum MetadataFetchType {
  Location = "location",
  Country = "country",
  ProductsHs92 = "productsHs92",
  ProductsHs12 = "productsHs12",
  ProductsHs22 = "productsHs22",
  ProductsSitc = "productsSitc",
  ProductYear = "productYear",
  ProductComplexity = "productComplexity",
  Deflators = "deflators",
  LocationYear = "locationYear",
}

export enum MetadataFetchStatus {
  Success = "success",
  Loading = "loading",
  Error = "error",
  Undefined = "undefined",
}

// NOTE: useFetchMetadata hook lives in src/sharedUtilities/useFetchMetadata.tsx.
// It is NOT re-exported here to avoid circular dependencies during dev
// (this package's barrel would pull in src/ which imports back from this package).
// Import it directly from src/ until it can be fully migrated.
